import { Component, Input, OnChanges, OnInit, SimpleChanges, inject } from '@angular/core';
import { PatientAttachmentLlmResultSet } from 'app/core/models/patient-attachment-llm-result-set.model';
import { AppToastService } from 'app/core/services/app-toast.service';
import { LlmFeedbackService } from 'app/core/services/llm-feedback.service';
import { DatePipe } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { PatientAttachment } from 'app/core/models/patient-attachment.model';
import { PatientAttachmentsService } from 'app/core/services/patient-attachments.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-consult-note-summary',
  templateUrl: './consult-note-summary.component.html',
  styleUrls: ['./consult-note-summary.component.scss'],
  imports: [FaIconComponent, NgbCollapse, FormsModule, DatePipe, MatProgressSpinnerModule]
})
export class ConsultNoteSummaryComponent implements OnChanges, OnInit {
  private patientAttachmentService = inject(PatientAttachmentsService)
  private llmFeedbackService = inject(LlmFeedbackService);
  private toastService = inject(AppToastService);

  @Input() patientAttachment: PatientAttachment;
  @Input() loadOnDemand = false;
  resultSet: PatientAttachmentLlmResultSet;
  summary: Record<string, any>;
  formCollapsed = true;
  feedback: string;
  showNewSpecialty = false;
  loading = false;

  ngOnInit(): void {
    this.resetForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['patientAttachment']) {
      if (this.patientAttachment?.patientAttachmentLlmResultSet) {
        this.resultSet = this.patientAttachment.patientAttachmentLlmResultSet;
        this.initValues();
      } else if (this.loadOnDemand && this.patientAttachment?.standardConsultNote) {
        this.loadResultSet();
      } else {
        this.resultSet = null;
        this.initValues();
      }
    }
  }

  onSaveClick(): void {
    this.llmFeedbackService.submitResultSetFeedback(this.resultSet.id, this.feedback).subscribe({
      complete: () => {
        this.toastService.show('Feedback submitted. Thanks!', { cssClass: 'bg-success-subtle' });
        this.resetForm();
      },
      error: () => this.toastService.show('An error occurred.', { cssClass: 'bg-danger-subtle' })
    });
  }

  private initValues() {
    this.loading = false;
    this.summary = this.resultSet?.summary;
    if (this.summary?.specialtyDetail?.specialty) {
      this.showNewSpecialty = true;
    }
  }

  private resetForm(): void {
    this.formCollapsed = true;
    this.feedback = "";
  }

  private loadResultSet() {
    this.loading = true;
    this.patientAttachmentService.getLlmResultSet(this.patientAttachment.id).subscribe({
      next: resultSet => {
        this.resultSet = resultSet;
        this.initValues();
      },
      error: () => {
        this.resultSet = null;
        this.initValues();
      }
    })
  }

}
